import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  CreateInvoiceProps,
  ExtractInvoiceProps,
  GetInvoiceProps,
} from 'entities/Invoice';

import {
  createInvoiceService,
  extractInvoiceDataService,
  getInvoiceListService,
  getInvoiceService,
} from 'services/invoices.service';

export const getInvoiceList = createAsyncThunk(
  'invoice/list',
  async (_, thunkApi) => {
    try {
      const response = await getInvoiceListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getInvoice = createAsyncThunk(
  'invoice/getInvoice',
  async (data: GetInvoiceProps, thunkApi) => {
    try {
      const response = await getInvoiceService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const extractInvoiceData = createAsyncThunk(
  'invoice/extractInvoiceData',
  async (data: ExtractInvoiceProps, thunkApi) => {
    try {
      const response = await extractInvoiceDataService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const createInvoice = createAsyncThunk(
  'invoice/createInvoice',
  async (data: CreateInvoiceProps, thunkApi) => {
    try {
      const response = await createInvoiceService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
